export var defaultProps = {
    className: '',
    style: undefined,
    loading: false,
    actions: [],
    shadow: 'none',
    bordered: true,
};
